import { addDoc, collection } from 'firebase/firestore';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { myFirestore } from './config';

const AdminPageAdd = () => {
    let navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = async data => {
        console.log(data);
        const myCollection = collection(myFirestore, 'page');
        const record = await addDoc(myCollection, data);
        console.log(record, `/admin/page/${record.id}`);
        navigate(`/admin/page/${record.id}`);
    };

    return (
        <>
            <h1 className="text-4xl">Add Page</h1>
            <div className="py-12 flex flex-col">
                <Link to="/admin/page" className="mb-6">
                    Back to page list
                </Link>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex flex-col border rounded px-2 pt-6 pb-3">
                        <label htmlFor="slug">Slug:</label>
                        <input
                            id="slug"
                            type="text"
                            {...register('slug', {
                                required: 'Slug is required',
                            })}
                            className="border rounded px-2 py-1"
                        />
                        {errors.slug && (
                            <span className="text-red-500 text-sm pt-3">
                                {errors.slug.message}
                            </span>
                        )}
                    </div>
                    <div className="pt-2">
                        <button
                            type="submit"
                            className="border rounded bg-gray-50 hover:bg-gray-100 px-3 py-1"
                        >
                            Add page
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AdminPageAdd;
